module.exports = __webpack_public_path__ + "static/FannyBenisek-Curriculumvitae(EN)-194f12e5bc77612559002176963976de.pdf";